module.exports = __webpack_public_path__ + "static/diop-5d365add2fbcb2cee6d38f1a2eb9bfde.png";